module.exports = __webpack_public_path__ + "static/img/badge-adulticide-scheduled.0d806d3.svg";